<template>
  <div class="category" v-if="categoryTreeList.childCategories && categoryTreeList.childCategories.length > 0">
    <div class="sub_heading flx">
      <h4>{{categoryTreeList.name}}</h4>
      <span class="see_all" @click="categoryListId(categoryTreeList.id, categoryTreeList.name)">{{$t('seeAll')}}</span>
    </div>
    <div class="product_list flx">
      <div class="category_card" v-for="(product,index) in categoryTreeList.childCategories" :key="index" @click="categoryProductById(product.id)">
        <div class="img_wrapper spinner_wrapper" v-lazyload v-if="product.bgImageURL">
            <ImageSpinner class="image_spinner" />
            <img :data-url="product.bgImageURL" alt="product" />
          </div>
        <h3>{{product.name}}</h3>
      </div>
    </div>
    
  </div>
</template>

<script>
import ImageSpinner from "../Common/ImageSpinner";
export default {
  name: "CategoryCard",
  components: {
    ImageSpinner
  },
  props: {
    categoriesTree: {
      type: Object
    },
    underPriceData: {
      type: Array
    }
  },
  watch: {
    categoriesTree(){
      this.categoryTreeList = this.categoriesTree
    }
  },
  data() {
    return {
       categoryTreeList: {}
    };
  },
  methods: {
    categoryListId(id, name){
      this.$router.onError(err => {
        if (/loading chunk \d* failed./i.test(err.message)) {
           window.location.reload()
        }
      });
      this.$router.push('/subcategory-listing/' + id + '?subCategoryname=' + name)
    },
    categoryProductById(categoryId){
      this.$router.onError(err => {
        if (/loading chunk \d* failed./i.test(err.message)) {
           window.location.reload()
        }
      });
      this.$router.push("/product-by-category?type=NORMAL&categoryid=" + categoryId);
    },
  },
  mounted(){
    this.categoryTreeList = this.categoriesTree
  }
};
</script>
